export const supportTickets = '/supportTickets'